export default __webpack_public_path__ + "static/media/blackShare.00933089.svg";